import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import PropTypes from 'prop-types';

const CssTransition = ({ children, ...props }) => (
    <CSSTransition
        {...props}
        timeout={props.timeoutInMs || 300}
        classNames={props.classNames || 'transition'}
    >
        {children}
    </CSSTransition>
);

CssTransition.propTypes = {
    children: PropTypes.object.isRequired,
    timeoutInMs: PropTypes.number,
    classNames: PropTypes.string
};

export default CssTransition;



// WEBPACK FOOTER //
// ./src/components/Transition/CssTransition.jsx